export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categoryName: string;
  imageSeq: string;
  author: string;
  publishDate: string;
  readTime: string;
  tags: string[];
}

export const articles: Article[] = [
  {
    slug: 'wynn-palace-suite-booking-guide',
    title: '永利皇宫套房预订全攻略：从房型选择到入住体验',
    excerpt: '详解永利皇宫各类套房房型差异、预订技巧与最佳入住时节，助您以最优价格享受尊贵住宿体验。',
    content: `<p>永利皇宫作为澳门路氹金光大道上最耀眼的度假胜地之一，以其独特的花卉主题和极致的奢华体验闻名于世。对于计划前往澳门的旅客而言，选择一间适合自己的套房是完美旅程的第一步。</p>

<h2>房型概览</h2>
<p>永利皇宫提供多种套房选择，从基础豪华客房到总统套房，每间客房均融合了现代奢华与东方美学。</p>

<h3>珀丽套房</h3>
<p>面积为60平方米的珀丽套房是永利皇宫的入门级套房，配备独立客厅与卧室，装饰以柔和的金色与奶油色调为主，落地窗可俯瞰表演湖或路氹城景。房间内设有一张特大号床，床品采用意大利Frette品牌，为您带来云端般的睡眠体验。</p>

<h3>行政套房</h3>
<p>行政套房面积达85平方米，拥有更为宽敞的起居空间和独立的用餐区域。浴室配备按摩浴缸和独立蒸汽淋浴间，选用宝格丽洗浴用品，细节之处尽显奢华品味。</p>

<h3>主席套房</h3>
<p>面积超过200平方米的主席套房是永利皇宫的顶级房型之一，设有私人健身房、桑拿房和独立管家服务入口。客厅配备施坦威钢琴，卧室拥有270度全景落地窗，可将澳门天际线尽收眼底。</p>

<h2>预订技巧</h2>
<p><strong>最佳预订时间：</strong>建议提前30-45天进行预订，尤其是在节假日和大型活动期间。永利皇宫经常推出早鸟优惠，提前预订可享受高达20%的折扣。</p>
<p><strong>会员权益：</strong>加入永利会（Wynn Rewards）会员计划，可享受专属折扣、免费升级和延迟退房等增值服务。新会员注册即可获得欢迎积分。</p>
<p><strong>淡旺季选择：</strong>澳门旅游旺季集中在农历新年、五一黄金周和十一黄金周期间，此时房价会显著上涨。若追求高性价比，建议选择3-4月或10月下旬至11月的工作日入住。</p>

<h2>入住体验亮点</h2>
<p>入住永利皇宫，您将享受到以下专属礼遇：</p>
<ul>
<li>24小时管家服务，满足您的一切需求</li>
<li>免费乘坐观光缆车，俯瞰表演湖壮丽景色</li>
<li>优先预订永利皇宫内米其林星级餐厅</li>
<li>专属入住通道，免排队等候</li>
<li>每日新鲜水果与精致点心赠送</li>
</ul>`,
    category: 'hotel',
    categoryName: '酒店预订',
    imageSeq: 'article-hotel-01',
    author: '永利皇宫体验官',
    publishDate: '2026-08-10',
    readTime: '8分钟',
    tags: ['套房预订', '入住攻略', '房型推荐', '优惠信息'],
  },
  {
    slug: 'wynn-palace-michelin-restaurants',
    title: '永利皇宫米其林星级餐厅全收录：舌尖上的奢华之旅',
    excerpt: '盘点永利皇宫内所有米其林星级及推荐餐厅，从粤式经典到环球美馔，带您领略顶级餐饮体验。',
    content: `<p>永利皇宫汇聚了澳门最顶尖的餐饮阵容，多家餐厅荣获米其林星级殊荣，为食客呈现无与伦比的美食盛宴。以下为您逐一介绍永利皇宫内的殿堂级餐厅。</p>

<h2>永利宫</h2>
<p><strong>米其林二星 | 粤菜</strong></p>
<p>由名厨谭国锋主理的永利宫，以传统粤菜为基础，融入现代烹饪技法，打造出一道道色香味俱全的艺术珍馐。餐厅内部装潢富丽堂皇，三面落地玻璃窗将表演湖美景尽收眼底。招牌菜品包括黑松露烧鹅、花胶炖椰子鸡汤和黄金虾球。人均消费约澳门币800-1500元。</p>

<h2>永利扒房</h2>
<p><strong>米其林一星 | 西餐</strong></p>
<p>永利扒房提供来自全球顶级产区的优质牛肉，包括日本A5和牛、澳洲M9和牛和美国USDA Prime级别牛肉。餐厅每30分钟上演一次精彩的剧场表演，将美食与艺术完美融合。推荐菜品有干式熟成T骨牛排、香煎鹅肝和黑松露薯蓉。人均消费约澳门币1000-2000元。</p>

<h2>"泓"日本料理</h2>
<p><strong>米其林二星 | 日本料理</strong></p>
<p>"泓"日本料理秉承传统江户前寿司精髓，由日本名厨亲自主理。所有食材均从日本空运而至，确保新鲜度达到最高标准。餐厅仅设12个吧台座位，用餐体验私密而尊贵。厨师发办套餐价格为澳门币2388元起。</p>

<h2>咖啡苑</h2>
<p><strong>米其林餐盘推荐 | 国际自助餐</strong></p>
<p>咖啡苑以丰盛的国际自助餐闻名，拥有11个现场烹饪台，提供从生猛海鲜到精致甜点的全方位美食体验。早餐价格为澳门币358元，午餐澳门币498元，晚餐澳门币688元。</p>

<h2>餐厅预订建议</h2>
<p>热门餐厅建议提前2-4周预订，特别是节假日期间。永利皇宫住客可通过礼宾部优先预订。部分米其林星级餐厅对着装有要求，建议穿着商务休闲装。</p>`,
    category: 'dining',
    categoryName: '餐厅推荐',
    imageSeq: 'article-dining-01',
    author: '永利皇宫美食顾问',
    publishDate: '2026-08-08',
    readTime: '10分钟',
    tags: ['米其林餐厅', '粤菜', '日本料理', '美食攻略'],
  },
  {
    slug: 'wynn-palace-performance-lake-show',
    title: '永利皇宫表演湖音乐喷泉：日夜不同的视觉盛宴',
    excerpt: '永利皇宫标志性的表演湖是全球最大的音乐喷泉之一，本文为您详解最佳观赏位置与演出时间表。',
    content: `<p>永利皇宫表演湖是澳门最令人叹为观止的免费景点之一，占地8英亩的湖面上，数千个喷泉嘴配合音乐、灯光与火焰效果，呈现出一场场震撼人心的水舞表演。</p>

<h2>演出时间</h2>
<p>表演湖每天从中午12:00开始，至午夜00:00结束，每30分钟上演一次。每场表演持续约3-5分钟，曲目编排定期更换，涵盖古典音乐、百老汇经典、流行金曲及中国民乐等多元风格。</p>

<h2>最佳观赏位置</h2>
<h3>观光缆车</h3>
<p>乘坐永利皇宫标志性的观光缆车是观赏表演湖的最佳方式。缆车环绕表演湖而行，从空中俯瞰水舞与灯光交织的壮丽画面。缆车对所有游客免费开放，运营时间为每日10:00至午夜。</p>

<h3>湖畔步道</h3>
<p>表演湖周边设有宽敞的湖畔步道，建议在表演开始前10分钟抵达以占据最佳位置。面向永利皇宫主楼的正面区域是拍摄全景的最佳角度。</p>

<h3>永利宫餐厅</h3>
<p>在永利宫靠窗座位用餐，可以一边品味米其林星级美食，一边欣赏表演湖的绚烂演出，是澳门最浪漫的用餐体验之一。</p>

<h2>表演亮点</h2>
<p>表演湖配备了超过2000个喷泉嘴和1000多盏LED灯，水柱最高可喷射至80米。夜间表演尤为壮丽，火焰特效与灯光配合，打造出如梦似幻的视觉效果。节假日期间还会推出特别编排的主题表演。</p>`,
    category: 'entertainment',
    categoryName: '娱乐体验',
    imageSeq: 'article-entertainment-01',
    author: '永利皇宫娱乐向导',
    publishDate: '2026-08-05',
    readTime: '6分钟',
    tags: ['表演湖', '音乐喷泉', '免费景点', '夜景'],
  },
  {
    slug: 'wynn-palace-luxury-shopping',
    title: '永利皇宫名店街购物指南：顶级品牌一站购齐',
    excerpt: '永利皇宫名店街汇聚超过50个国际奢侈品牌，为您详解各品牌位置、特色单品与购物贴士。',
    content: `<p>永利皇宫名店街是澳门最精致的奢侈品购物目的地之一，汇集了Chanel、Hermès、Louis Vuitton、Gucci、Prada、Cartier、Van Cleef & Arpels等超过50个国际顶级品牌，为宾客提供尊贵的购物体验。</p>

<h2>品牌分布</h2>
<h3>一层：珠宝腕表区</h3>
<p>一层集中了Cartier卡地亚、Van Cleef & Arpels梵克雅宝、Tiffany & Co.蒂芙尼、Rolex劳力士和Patek Philippe百达翡丽等顶级珠宝腕表品牌。每家店铺均提供私人购物顾问服务，为您推荐最适合的款式。</p>

<h3>二层：时装皮具区</h3>
<p>二层汇集了Chanel香奈儿、Hermès爱马仕、Louis Vuitton路易威登、Dior迪奥和Gucci古驰等顶级时装品牌旗舰店。各品牌旗舰店均备有当季最新系列和部分限量款式。</p>

<h2>购物贴士</h2>
<p><strong>免税优势：</strong>澳门为免税港，所有商品均免征关税和增值税，较内地价格优惠约15%-30%。</p>
<p><strong>会员积分：</strong>使用永利会会员卡消费可累积积分，积分可兑换酒店住宿、餐饮和水疗等礼遇。每消费澳门币1元积1分。</p>
<p><strong>私人购物服务：</strong>永利皇宫提供免费的私人购物顾问服务，可为您安排专属导购、品牌预约和商品预留。建议提前24小时预约。</p>
<p><strong>支付方式：</strong>支持银联、Visa、Mastercard、American Express、微信支付和支付宝等多种支付方式。</p>`,
    category: 'shopping',
    categoryName: '购物指南',
    imageSeq: 'article-shopping-01',
    author: '永利皇宫时尚编辑',
    publishDate: '2026-08-03',
    readTime: '7分钟',
    tags: ['奢侈品购物', '免税', '品牌旗舰店', '购物攻略'],
  },
  {
    slug: 'macau-three-day-itinerary',
    title: '澳门三天两夜深度游攻略：永利皇宫为据点的完美行程',
    excerpt: '以永利皇宫为据点的澳门三天深度游行程，涵盖历史文化、美食探索与休闲娱乐的完美组合。',
    content: `<p>澳门虽小，却是一座值得细细品味的城市。以永利皇宫为据点，我们为您规划了一条三天两夜的完美路线，兼顾历史文化探索、美食品鉴与休闲娱乐。</p>

<h2>第一天：路氹金光大道</h2>
<p><strong>上午：</strong>抵达澳门后，乘坐永利皇宫免费穿梭巴士直达酒店。办理入住后，先在房间内小憩片刻，享受欢迎水果与茶点。</p>
<p><strong>下午：</strong>乘坐观光缆车俯瞰表演湖全景，随后前往永利皇宫名店街购物。建议预留2-3小时，各大品牌旗舰店值得细细逛。</p>
<p><strong>晚上：</strong>在永利宫享用米其林二星粤菜晚餐，餐厅靠窗座位正对表演湖，可边用餐边欣赏音乐喷泉表演。餐后漫步湖畔步道，感受澳门夜色的迷人魅力。</p>

<h2>第二天：澳门半岛文化之旅</h2>
<p><strong>上午：</strong>前往澳门半岛，游览大三巴牌坊、大炮台和澳门博物馆，感受澳门四百年的中西文化交融。建议乘坐出租车前往，车程约15分钟。</p>
<p><strong>中午：</strong>在官也街品尝地道澳门美食，推荐安德鲁饼店的葡式蛋挞、莫义记的榴莲雪糕和诚昌饭店的水蟹粥。</p>
<p><strong>下午：</strong>参观龙环葡韵住宅式博物馆和路氹历史馆，感受澳门独特的土生葡人文化。随后返回永利皇宫，在水疗中心享受60分钟的东方经络按摩，放松身心。</p>
<p><strong>晚上：</strong>在永利扒房享用米其林一星的顶级牛排晚餐，体验剧场式用餐的独特魅力。</p>

<h2>第三天：休闲收官</h2>
<p><strong>上午：</strong>在咖啡苑享用丰盛的自助早餐后，前往泳池畅游片刻，或是在健身中心进行简单的晨间锻炼。</p>
<p><strong>中午：</strong>在"泓"日本料理品尝正宗厨师发办寿司套餐，为旅程画上完美的句号。</p>
<p><strong>下午：</strong>办理退房手续，乘坐免费穿梭巴士前往澳门国际机场或港澳码头，结束愉快的澳门之旅。</p>

<h2>实用贴士</h2>
<ul>
<li>澳门流通货币为澳门币，港币亦广泛接受，汇率约为1:1</li>
<li>建议下载澳门旅游局官方App获取实时景点信息和交通指引</li>
<li>永利皇宫提供免费行李寄存服务，退房后仍可轻松游玩</li>
<li>澳门天气炎热潮湿，建议随身携带防晒用品和饮用水</li>
</ul>`,
    category: 'travel',
    categoryName: '旅游攻略',
    imageSeq: 'article-travel-01',
    author: '永利皇宫旅行规划师',
    publishDate: '2026-07-28',
    readTime: '12分钟',
    tags: ['澳门攻略', '三天行程', '自由行', '深度游'],
  },
  {
    slug: 'wynn-palace-spa-experience',
    title: '永利皇宫水疗中心深度体验：东方养生与西方芳疗的完美融合',
    excerpt: '永利皇宫水疗中心荣获多项国际大奖，本文为您详细介绍特色疗程、环境设施与预订建议。',
    content: `<p>永利皇宫水疗中心是一处闹市中的静谧绿洲，占地超过4000平方米，融合东方传统养生智慧与西方现代芳疗科技，连续多年荣获Forbes Travel Guide五星大奖。</p>

<h2>环境设施</h2>
<p>水疗中心设有22间独立理疗室，包括4间双人套房和2间配备私人按摩浴缸的VIP套房。内部设计以金色和暖色调为主，配合柔和的灯光与舒缓的音乐，营造出宁静致远的氛围。每间理疗室均配备私人更衣室、淋浴间和蒸汽浴室。</p>

<h2>特色疗程推荐</h2>
<h3>帝王玉石热石按摩（120分钟）</h3>
<p>采用温热的玉石配合瑞典式深层按摩手法，有效缓解肌肉疲劳，促进血液循环。疗程开始前提供足浴仪式，结束后赠送养生花茶与手工点心。价格：澳门币2880元。</p>

<h3>东方经络平衡疗程（90分钟）</h3>
<p>结合中医经络理论与指压按摩技法，针对身体各大穴位进行精准按压，疏通经络，调和气血。特别适合长期伏案工作、肩颈不适的宾客。价格：澳门币1980元。</p>

<h3>极致活颜面部护理（90分钟）</h3>
<p>选用瑞士殿堂级护肤品牌Valmont产品，配合专业面部按摩手法，深层清洁、滋养和提拉面部肌肤。价格：澳门币2380元。</p>

<h2>预订建议</h2>
<p>建议提前3天以上预约，周末和节假日更为抢手。住客可享受9折优惠。水疗中心营业时间为每日10:00至22:00，最后预约时间为20:00。</p>`,
    category: 'entertainment',
    categoryName: '娱乐体验',
    imageSeq: 'article-entertainment-02',
    author: '永利皇宫水疗顾问',
    publishDate: '2026-07-25',
    readTime: '8分钟',
    tags: ['水疗体验', '按摩', '养生', '美容'],
  },
  {
    slug: 'wynn-palace-family-friendly',
    title: '永利皇宫亲子度假指南：让孩子也爱上奢华假期',
    excerpt: '永利皇宫不仅是成人度假天堂，也为亲子家庭提供丰富的儿童设施与活动，让全家共享欢乐时光。',
    content: `<p>永利皇宫虽然以奢华度假闻名，但同样为亲子家庭提供了丰富多彩的儿童设施与活动，是澳门最适合家庭出游的综合度假胜地之一。</p>

<h2>亲子友好设施</h2>
<h3>儿童俱乐部</h3>
<p>永利皇宫为入住家庭的儿童准备了专属的儿童俱乐部，面积超过500平方米，设有游戏区、手工坊和迷你电影院。3-12岁儿童可在专业人员的看护下享受各类趣味活动，父母则可安心享受二人世界。</p>

<h3>家庭泳池</h3>
<p>酒店设有专门的儿童泳池区，水深仅0.3-0.6米，配备水上滑梯和喷水设施，让孩子们尽情嬉水。泳池区周围设有充足的日光躺椅和遮阳伞，家长可在一旁轻松看护。</p>

<h2>亲子餐饮</h2>
<p>咖啡苑提供专门的儿童自助餐区域，菜品以健康、美味、造型可爱为特色。永利扒房也提供儿童套餐，包括迷你汉堡、意面和炸鱼薯条等孩子们喜爱的美食。</p>

<h2>周边亲子景点</h2>
<p>永利皇宫地理位置优越，步行可至澳门科学馆（约15分钟车程）和澳门大熊猫馆（约20分钟车程），是亲子一日游的理想选择。表演湖的喷泉表演也同样令孩子们着迷。</p>`,
    category: 'travel',
    categoryName: '旅游攻略',
    imageSeq: 'article-travel-02',
    author: '永利皇宫家庭顾问',
    publishDate: '2026-07-20',
    readTime: '6分钟',
    tags: ['亲子度假', '家庭出游', '儿童设施', '亲子攻略'],
  },
  {
    slug: 'wynn-palace-wedding-venue',
    title: '永利皇宫梦幻婚礼全指南：打造澳门最浪漫的婚礼盛典',
    excerpt: '永利皇宫是澳门最受欢迎的婚礼场地之一，本文为您详解婚礼套餐、场地选择和策划服务。',
    content: `<p>永利皇宫是澳门最具浪漫气息的婚礼场地，无论是盛大的宴会厅婚礼还是私密的花园仪式，专业婚礼策划团队都能为您打造梦想中的完美婚礼。</p>

<h2>婚礼场地</h2>
<h3>永利皇宫宴会厅</h3>
<p>无柱式设计的大宴会厅面积达2000平方米，挑高8米，可容纳500位宾客。配备顶级音响灯光系统和可定制的舞台背景，是举办盛大婚礼的不二之选。</p>

<h3>湖景露台</h3>
<p>面向表演湖的露天婚礼场地，可容纳80-120位宾客。以音乐喷泉为背景，在夕阳余晖中交换誓言，浪漫值满分。</p>

<h2>婚礼套餐</h2>
<p>永利皇宫提供多档婚礼套餐，定价从澳门币188,888元起。套餐包含：场地布置、婚礼策划、摄影摄像、新娘化妆、婚宴菜单、婚礼蛋糕和豪华婚房一晚住宿。</p>

<p>建议提前6个月以上预订，热门日期（如5月、10月的周末）尤为紧张。</p>`,
    category: 'entertainment',
    categoryName: '娱乐体验',
    imageSeq: 'article-entertainment-03',
    author: '永利皇宫婚礼策划师',
    publishDate: '2026-07-15',
    readTime: '7分钟',
    tags: ['婚礼场地', '婚宴', '浪漫婚礼', '宴会'],
  },
];